import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const BannerPage = Loadable(lazy(() => import('pages/Banner/Banner')));
const ErrorPage = Loadable(lazy(() => import('pages/error_page')));
import PublicRoute from './PublicRoute';
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  errorElement: <ErrorPage />,
  children: [
    {
      index: true,
      element: (<PublicRoute> <LoginPage /> </PublicRoute>)
    },
    {
      path: 'login',
      element: (<PublicRoute> <LoginPage /> </PublicRoute>)
    },
    // {
    //   path: 'register',
    //   element: (<PublicRoute> <RegisterPage /> </PublicRoute>)
    // },
    {
      path: 'banner/:id',
      element: (<BannerPage />)
    }
  ]
};


// ORIGINAL
// const LoginRoutes = {
//   path: '/',
//   children: [
//     {
//       path: '/',
//       children: [
//         {
//           path: '/login',
//           element: <LoginPage />
//         },
//         {
//           path: '/register',
//           element: <RegisterPage />
//         }
//       ]
//     }
//   ]
// };



export default LoginRoutes;
